import React from "react";

export function WB_CustomLeadersTeamLeaders({}) {
    return <div>
        WB_CustomLeadersTeamLeaders
    </div>
}